import { STRING_getInstance7xungxdjbzv as STRING_getInstance } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { PrimitiveSerialDescriptor3egfp53lutxj2 as PrimitiveSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialDescriptors.mjs';
import {
  Companion_instance3t7kgujds2u7a as Companion_instance,
  YearMonth22nahmknr467s as YearMonth,
} from '../YearMonth.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var YearMonthSerializerClass;
function YearMonthSerializer() {
  if (YearMonthSerializerClass === VOID) {
    class $ {
      constructor() {
        YearMonthSerializer_instance = this;
        this.descriptor_1 = PrimitiveSerialDescriptor('kotlinx.datetime.YearMonth', STRING_getInstance());
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      deserialize_sy6x50_k$(decoder) {
        return Companion_instance.parse$default_epr5sf_k$(decoder.decodeString_x3hxsx_k$());
      }
      serialize_dqatp5_k$(encoder, value) {
        encoder.encodeString_424b5v_k$(value.toString());
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_dqatp5_k$(encoder, value instanceof YearMonth() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'YearMonthSerializer', VOID, VOID, [KSerializer()]);
    YearMonthSerializerClass = $;
  }
  return YearMonthSerializerClass;
}
var YearMonthSerializer_instance;
function YearMonthSerializer_getInstance() {
  if (YearMonthSerializer_instance === VOID)
    new (YearMonthSerializer())();
  return YearMonthSerializer_instance;
}
//region block: exports
export {
  YearMonthSerializer_getInstance as YearMonthSerializer_getInstance1mubu03fd28xn,
};
//endregion

//# sourceMappingURL=YearMonthSerializers.mjs.map
